import { BaseService } from "services/_baseService";
import appAxios from "services/axios";

class MessagesAdminService extends BaseService<any> {
  constructor() {
    super(`chats`);
  }

  // Получаем сообщения по ID чата
  getMessagesByChatID = async (chatID: number, queryParams: object) => {
    return appAxios.get(`${this.pathWithOrg()}/chats/${chatID}/messages`, { params: queryParams });
  };

  // Удаляем сообщение
  deleteMessage = async (chatID: number, messageID: number) => {
    return appAxios.delete(`${this.pathWithOrg()}/${chatID}/messages/${messageID}`);
  };
}

export default new MessagesAdminService();
